import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-68951883"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "IntroPersonality"
};
var _hoisted_2 = {
  key: 0,
  "class": "ReadingPanel"
};
var _hoisted_3 = {
  "class": "ReadingPanel__box"
};
var _hoisted_4 = {
  "class": "ReadingPanel__label"
};
var _hoisted_5 = {
  "class": "ReadingPanel__content"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#FFF",
      "text-shadow": "7px -2px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "32px",
      "font-style": "normal",
      "font-weight": "700",
      "text-align": "left",
      "max-width": "392px",
      "margin": "0 auto",
      "margin-top": "19px",
      "width": "90vw",
      "line-height": "27px"
    }
  }, " Perfect! ", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "left",
      "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "24px",
      "font-style": "normal",
      "font-weight": "300",
      "line-height": "normal",
      "max-width": "392px",
      "margin": "0 auto",
      "margin-top": "6px",
      "width": "90vw"
    }
  }, " Now, let's customize your AIVitar ", -1);
});
var _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100vw",
    "max-width": "400px",
    "padding": "10px",
    "gap": "15px",
    "margin": "0 auto"
  }
};
var _hoisted_9 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_10 = {
  "class": "avatar__holder"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  "class": "avatar__name"
};
var _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div style=\"flex:1;\" data-v-68951883><div class=\"row row--completed\" data-v-68951883><div class=\"active-icon\" data-v-68951883><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"30\" viewBox=\"0 0 23 30\" fill=\"none\" data-v-68951883><g filter=\"url(#filter0_d_31_723)\" data-v-68951883><path d=\"M2.6556 24.3108L13.5893 15.0547C13.7654 14.9055 13.9068 14.7204 14.0038 14.5122C14.1007 14.3039 14.1509 14.0774 14.1509 13.8482C14.1509 13.619 14.1007 13.3925 14.0038 13.1842C13.9068 12.9759 13.7654 12.7909 13.5893 12.6417L2.6556 3.38554C1.61197 2.50217 -6.39271e-05 3.23456 -6.40458e-05 4.59205L-6.56644e-05 23.107C-6.57831e-05 24.4645 1.61197 25.1969 2.6556 24.3108Z\" fill=\"white\" data-v-68951883></path></g><defs data-v-68951883><filter id=\"filter0_d_31_723\" x=\"-0.00012207\" y=\"0\" width=\"22.151\" height=\"29.6981\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-68951883><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-68951883></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-68951883></feColorMatrix><feOffset dx=\"4\" dy=\"1\" data-v-68951883></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-68951883></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-68951883></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-68951883></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_31_723\" data-v-68951883></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_31_723\" result=\"shape\" data-v-68951883></feBlend></filter></defs></svg></div> Voice </div><div class=\"row\" data-v-68951883>Personality</div><div class=\"row row--upcoming\" data-v-68951883>interests</div><button class=\"skip-this\" data-v-68951883>Skip Personalization</button></div>", 1);
var _hoisted_14 = {
  "class": "content__holder"
};
var _hoisted_15 = {
  "class": "content__title"
};
var _hoisted_16 = {
  key: 0,
  "class": "content-row-label"
};
var _hoisted_17 = {
  "class": "content-row-label--profile"
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  "class": "bottomHolder"
};
var _hoisted_20 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "max-width": "400px",
    "bottom": "0px",
    "margin": "0px auto"
  }
};
var _hoisted_21 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1"
  }
};
var _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"backbutton__icon\" data-v-68951883><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"31\" viewBox=\"0 0 23 31\" fill=\"none\" data-v-68951883><g filter=\"url(#filter0_d_30_369)\" data-v-68951883><path d=\"M12.1557 4.04764L1.222 13.3038C1.04586 13.453 0.904464 13.6381 0.807527 13.8463C0.71059 14.0546 0.6604 14.2811 0.6604 14.5103C0.6604 14.7395 0.71059 14.966 0.807527 15.1743C0.904464 15.3825 1.04586 15.5676 1.222 15.7168L12.1557 24.973C13.1993 25.8563 14.8113 25.1239 14.8113 23.7664V5.25151C14.8113 3.89402 13.1993 3.16163 12.1557 4.04764Z\" fill=\"white\" data-v-68951883></path></g><defs data-v-68951883><filter id=\"filter0_d_30_369\" x=\"0.6604\" y=\"0.66037\" width=\"22.1509\" height=\"29.6981\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-68951883><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-68951883></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-68951883></feColorMatrix><feOffset dx=\"4\" dy=\"1\" data-v-68951883></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-68951883></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-68951883></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-68951883></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_30_369\" data-v-68951883></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_30_369\" result=\"shape\" data-v-68951883></feBlend></filter></defs></svg></div><div class=\"button__label\" data-v-68951883>Back</div>", 2);
var _hoisted_24 = [_hoisted_22];
var _hoisted_25 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_26 = {
  "class": "button__label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$data.showReadingPanel ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.profileLabelToRead), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($data.profileContentToRead), 1)]), _createElementVNode("button", {
    "class": "button ReadingPanel__close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.showReadingPanel = false;
    })
  }, "Close")])) : _createCommentVNode("", true), _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    "class": "avatar__image",
    src: _ctx.$store.state.selectedGalleryAvatar.image
  }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$store.state.selectedGalleryAvatar.name), 1)]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createTextVNode("Now, Select The Personality Profile You "), _createElementVNode("div", null, "Would Like " + _toDisplayString(_ctx.$store.state.selectedGalleryAvatar.name) + " To Use", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.actualProfileList, function (profile, profileID) {
    return _openBlock(), _createElementBlock("div", {
      "class": "content-row",
      key: profile.label
    }, [profile.XXX === true && _ctx.$store.state.appExpectations.romantic || profile.XXX === false ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_createTextVNode(_toDisplayString(profile.label) + " ", 1), _createElementVNode("div", _hoisted_17, _toDisplayString(profile.profile), 1)])) : _createCommentVNode("", true), profile.XXX === true && _ctx.$store.state.appExpectations.romantic || profile.XXX === false ? (_openBlock(), _createElementBlock("button", {
      key: 1,
      "class": _normalizeClass({
        'content-row-button': true,
        'content-row-button--selected': profile.selected || _ctx.$store.state.customerSelectedProfile == profile.label
      }),
      onClick: function onClick($event) {
        return $options.selectPersonality(profileID);
      }
    }, _toDisplayString(profile.selected || _ctx.$store.state.customerSelectedProfile == profile.label ? 'Selected' : 'Select'), 11, _hoisted_18)) : _createCommentVNode("", true)]);
  }), 128))])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [!this.$store.state.singleIntroSave ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("button", {
    "class": "button",
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.backButton();
    })
  }, _hoisted_24)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [_createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--secondary': true,
      'button--not-ready': !this.$store.state.customerSelectedProfile || this.$store.state.customerSelectedProfile == ''
    }),
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.acceptPersonality();
    })
  }, [_createElementVNode("div", _hoisted_26, _toDisplayString(!this.$store.state.customerSelectedProfile || this.$store.state.customerSelectedProfile == '' ? 'Awaiting Selection' : 'Accept Personality'), 1)], 2)])])])]);
}